import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FaClose from 'react-icons/lib/fa/close';


const DefaultLayout = ({ onCloseClick, title, body, image, imageCaption, imageCredit }) => (
  <div className="modal-default-layout">
    <header className="modal-header pb-0" style={{ border: 0 }}>
      <h2 className="heading-display">{title}</h2>
      <div className="modal-close" onClick={onCloseClick}>
        <FaClose />
      </div>
    </header>
    <div className="modal-content">
      <div>
        {!!image && (
          <div className="py-2">
            <img src={image} alt="" />
          </div>
        )}
        {!!imageCredit && <div className="meta text-right mb-1" dangerouslySetInnerHTML={{ __html: imageCredit }} />}
        {!!imageCaption && (
          <Fragment>
            <div className="caption mb-2" dangerouslySetInnerHTML={{ __html: imageCaption }} />
            <hr />
          </Fragment>
        )}
        <div className="body-copy" dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </div>
  </div>
);

DefaultLayout.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  image: PropTypes.string,
  imageCaption: PropTypes.string,
  imageCredit: PropTypes.string,
};

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/components/Modal/DefaultLayout.js